export const AMOUNT_COLUMN = 'Amount';
export const PERIOD_CELL_CLASS_NAME = 'NSTable__tbody__tr__td text-dark text-right';
export const TOTAL_PERIOD_CELL_CLASS_NAME = 'NSTable__tfoot__tr__td text-right';
export const TOTAL_LABEL = 'Total';
